import { useEffect } from 'react';
import type { RefObject } from 'react';

/** Closes an open menu on a click outside `rootRef` or on Escape. */
export const useMenuDismiss = (open: boolean, rootRef: RefObject<HTMLElement | null>, close: () => void): void => {
    useEffect(() => {
        if (!open) return;
        const closeOnOutsideClick = (e: MouseEvent) => {
            if (!rootRef.current?.contains(e.target as Node)) close();
        };
        const closeOnEscape = (e: KeyboardEvent) => { if (e.key === 'Escape') close(); };
        document.addEventListener('mousedown', closeOnOutsideClick);
        document.addEventListener('keydown', closeOnEscape);
        return () => {
            document.removeEventListener('mousedown', closeOnOutsideClick);
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [open, rootRef, close]);
};
